import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import Hero from './Hero';
import WhyChooseUs from './WhyChooseUs';
import ProcessSection from './ProcessSection';
import ServicesSection from './ServicesSection';
import PortfolioSection from './PortfolioSection';
import TestimonialsSection from './TestimonialsSection';
import CTASection from './CTASection';

/**
 * HomePage component
 * Combines all homepage sections into a complete page
 * Supports multiple languages through i18n
 */
const HomePage = () => {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>{t('meta.title')}</title>
        <meta name="description" content={t('meta.description')} />
        <meta name="keywords" content={t('meta.keywords')} />
      </Helmet>
      
      <Hero />
      <WhyChooseUs />
      <ProcessSection />
      <ServicesSection />
      <PortfolioSection />
      <TestimonialsSection />
      <CTASection />
    </>
  );
};

export default HomePage;
